import { render, staticRenderFns } from "./RestricaoClienteForm.vue?vue&type=template&id=4e51b9ce&"
import script from "./RestricaoClienteForm.vue?vue&type=script&lang=js&"
export * from "./RestricaoClienteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports